import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
import { WHATSAPP_ORDER_LINK, PHONE_DISPLAY } from '../utils/whatsapp';
export function FinalCta() {
  return <section className="w-full bg-night-900 px-4 py-16 sm:px-6 sm:py-20" data-id="element-43" data-mp="19fgx47jk9i91">
      <div className="mx-auto w-full max-w-6xl rounded-3xl border border-aqua-400/25 bg-night-800 px-6 py-12 text-center sm:px-10 sm:py-14" data-id="element-44" data-mp="15ddgl4i1bngw">
        <h2 className="font-display text-2xl font-semibold uppercase tracking-wide text-white sm:text-3xl" data-id="element-45" data-mp="1jc3fmpoezx7w">
          ¿Ya sabés qué sabor querés probar?
        </h2>
        <div className="mx-auto mt-3 h-px w-24 bw-gold-rule" aria-hidden="true" data-id="element-46" data-mp="1t2on72m2gc2y" />
        <p className="mx-auto mt-4 max-w-lg text-[14px] leading-relaxed text-white/60 sm:text-[15px]" data-id="element-47" data-mp="1t4r8xag6rj1v">
          Escribinos por WhatsApp, confirmá disponibilidad y armá tu pedido con
          empanadas argentinas premium hechas en Costa Rica.
        </p>
        <div className="mt-7 flex justify-center" data-id="element-48" data-mp="1x5uorwy8hf33">
          <CtaButton href={WHATSAPP_ORDER_LINK} track="whatsapp-final-click" data-id="element-49" data-mp="n5m7u6mvmc3z">
            Pedir por WhatsApp
          </CtaButton>
        </div>
        <p className="mt-5 inline-flex items-center gap-2 text-[13px] text-gold-400" data-id="element-50" data-mp="s5gws4n3crme">
          <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-51" data-mp="x3iofdyl1z9h" />
          {PHONE_DISPLAY}
        </p>
      </div>
    </section>;
}